import React from "react";

export default function Logo(){
    return (
        <div className="text-white text-3xl relative lg:absolute  lg:-translate-x-1/2 left-0 lg:left-1/2">
            Kuts
        </div>
    )
}